export default "__VITE_ASSET__BK_CT0rU__"